// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"f9436c23","267":"47087733","656":"5369e7d3","921":"a4daee6e"}[chunkId] + ".chunk.js";
};